import { Table } from "antd";
import React, { useEffect, useState } from "react";
import AxiosInstance from "../../../../AxiosInstance";
import moment from "moment";
import { debounce } from "lodash"; // Importing debounce from lodash

export default function PartnerAllReferView() {
  const [loading, setLoading] = useState(true);
  const [paginationMetaData, setPaginationMetaData] = useState({});
  var [dataSource, setDataSource] = useState([]);
  const [searchTerm, setSearchTerm] = useState(""); // State for search term

  useEffect(() => {
    getTableData(0, searchTerm); // Fetch data when search term changes or on mount
  }, [searchTerm]); // Re-run the effect when the search term changes

  const getTableData = async (skip, searchTerm) => {
    const url = `/partner/referral?take=10&skip=${skip}`;

    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        setDataSource(data?.data ?? []);
        setPaginationMetaData(data.paginationMetaData ?? {});
        setLoading(false);
      })
      .catch((err) => {});
  };

  const columns = [
    {
      title: "Refer Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text, policy) => moment(policy.createdAt).format("DD/MM/YYYY"),
    },
    {
      title: "Referred User Profile",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Name of User",
      dataIndex: "name",
      key: "name",
      render: (text, policy) => policy["firstName"] + " " + policy["lastName"],
    },
    {
      title: "User Email ID",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "User Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
  ];

  const change = (data) => {
    getTableData((data - 1) * 10, searchTerm);
  };

  // Debounced function for search input
  const debouncedSearch = debounce((value) => {
    setSearchTerm(value); // Update the search term state
  }, 500); // Wait for 500ms after the user stops typing

  return (
    <div>
      <Table
        bordered={true}
        scroll={{ x: 400 }}
        loading={loading}
        className="table"
        dataSource={[...dataSource]}
        columns={columns}
        pagination={{
          pageSize: 10,
          total: paginationMetaData.count,
          onChange: change,
        }}
      />
    </div>
  );
}
